import {Component, computed, inject, signal} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RuleCheckerService} from '../../../services/store/rule-checker.service';
import {DataService} from '../../../services/store/data.service';

/**
 * This component checks for store errors and displays them.
 */
@Component({
  selector: 'app-rule-checker',
  templateUrl: './rule-checker.component.html',
  styleUrls: ['./rule-checker.component.less'],
  imports: [CommonModule]
})
export class RuleCheckerComponent {

  private ruleCheckerService = inject(RuleCheckerService);
  private dataService = inject(DataService);

  /** `True` if store errors should be displayed. */
  showErrors = signal(false);

  /** `True` if request to backend to get store errors is in progress. */
  isLoading = computed(() => this.ruleCheckerService.loading());

  /** Rota errors for a store. */
  rotaErrors = computed(() => this.ruleCheckerService.rotaErrors());

  /** `True` if there are any error messages for a store. */
  hasErrorsOrWarnings = computed(() => !this.isLoading() && this.rotaErrors().length > 0);

  /** `True` if all error messages are just warnings. */
  hasOnlyWarnings = computed(() =>
          !this.isLoading() && this.rotaErrors().every(errorMessage => errorMessage.includes('Warning'))
  );

  /**
   * Checks for store errors on component initialization.
   */
  constructor() {
    this.ruleCheckerService.loading.set(false);
    this.ruleCheckerService.rotaErrors.set([]);
    if (this.dataService.selectedStore) {
      this.ruleCheckerService.check();
    }
  }

  /** Toggles the visibility of errors. */
  toggleErrors(): void {
    this.showErrors.update(v => !v);
  }
}